<template>
  <pt-detection-table class="pt-detection-table__withData" ref="table" :request-data="getDataList" :page-size="pageSize"
  :total-number="Number(totalNumber)" :table-data="tableData" :category="category" :isOutside="isOutside">
    <template slot-scope="scope">
      <slot :row="scope.row"></slot>
    </template>
  </pt-detection-table>
</template>

<script>
import PtDetectionTable from './index'
export default {
  name: 'pt-detection-table__withData',
  components: {
    'pt-detection-table': PtDetectionTable
  },
  data () {
    return {
      pageSize: 10,
      totalNumber: 0,
      tableData: [],
      currentParams: {},
      isOutside: false,
      category: ''
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    isFromRouter: {
      type: Boolean,
      default: false
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  watch: {
    paramsData (val) {
      this.category = val.category
      if (val.chineseName) {
        this.resetPage()
      }
      if (!this.isFromRouter) {
        this.resetPage()
      } else {
        this.isOutside = true
        this.currentParams.category = val.category
        this.getDataList(this.page)
      }
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getDataList (page, next, size) {
      let data = {
        page: page,
        size: size || this.pageSize,
        getAllConfigs: false,
        getCorpus: false,
        sort: 'id,desc',
        ...this.paramsData
      }
      this.$store.dispatch('getDetectionListByFilter', data).then(res => {
        if (next) {
          next(res.data)
        }
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        this.$emit('getAllSize', this.totalNumber)
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err)
      })
    },
    // 筛选数据的参数,不传默认为{}
    reload (params = {}) {
      this.currentParams = params
      this.$refs.table.reload()
    }
  }
}
</script>
